// extracted by mini-css-extract-plugin
export default {"root":"IconRecenter_root__7biXz"};